<template>
  <full-bleed-layout :show-leaderboard-ad="loading === 0">
    <loading-spinner v-if="loading !== 0" />
    <div
      v-else-if="user"
      class="status-updates"
      data-test-id="member-profile-by-id-status-updates"
    >
      <profile-header :user="user" />
      <div class="profile__header">
        <my-profile-button />
        <h1 class="status-updates__heading">
          {{ headingText }}
        </h1>
      </div>
      <div class="profile__container">
        <single-status v-if="userProfileStatus" :status="userProfileStatus" />
      </div>
    </div>
  </full-bleed-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfileHeader from '@/components/User/ProfileHeader.vue';
import SingleStatus from '@/components/User/Statuses/SingleStatus.vue';
import MyProfileButton from '@/components/User/MyProfileButton.vue';
import scrollToRouteHashMixin from '@/mixins/scroll-to-fragment-mixin';
import { GET_USER_PROFILE_QUERY, GET_SINGLE_USER_STATUS_QUERY } from '@/graphql/queries/user-queries';

export default {
  name: 'MemberProfileStatusById',
  components: {
    ProfileHeader,
    MyProfileButton,
    SingleStatus,
  },
  mixins: [scrollToRouteHashMixin],
  data() {
    return {
      user: {},
      userProfileStatus: null,
      slug: this.$route.params.slug,
      loading: 0,
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isCurrentUser() {
      return this.user.id === this.currentUser.id;
    },
    headingText() {
      return this.isCurrentUser ? 'My Status Updates' : `${this.user.username}'s Status Updates`;
    },
    routeHasReplyHash() {
      return this.$route.hash.match(/upsr-/);
    },
  },
  watch: {
    user(to) {
      if (!to) { return; }
      this.onLoad();
    },
  },
  updated() {
    if (this.routeHasReplyHash) {
      window.setTimeout(this.scrollToRouteHash, 0);
    }
  },
  methods: {
    onLoad() {
      const dataLayer = JSON.stringify({
        post_categories: ['profile'],
        has_user_generated_content: true,
      });
      this.$emit('loaded', dataLayer);
    },
  },
  metaInfo() {
    if (!this.loading && this.user) {
      return {
        title: `${this.user.username} - Status Update`,
        meta: [
          {
            name: 'robots',
            vmid: 'robots',
            content: 'noindex, follow',
          },
        ],
        link: [
          { vmid: 'canonical', content: null },
        ],
      };
    }
    return {};
  },
  apollo: {
    user: {
      query: GET_USER_PROFILE_QUERY,
      variables() {
        return {
          slug: this.slug.toLowerCase(),
        };
      },
    },
    userProfileStatus: {
      query: GET_SINGLE_USER_STATUS_QUERY,
      variables() {
        return {
          id: this.$route.params.id,
          slug: this.slug.toLowerCase(),
        };
      },
    },
  },

};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_status-updates';
  @import '@/stylesheets/components/_profile';
</style>
